'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgClock = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 72 72",
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M65.25 36c0 16.154-13.096 29.25-29.25 29.25S6.75 52.154 6.75 36 19.846 6.75 36 6.75 65.25 19.846 65.25 36zM0 36c0 19.882 16.118 36 36 36s36-16.118 36-36S55.882 0 36 0 0 16.118 0 36zm32.625-19.125V36a3.39 3.39 0 0 0 1.505 2.813l13.5 9a3.367 3.367 0 0 0 4.682-.943 3.364 3.364 0 0 0-.942-4.682L39.375 34.2V16.875A3.367 3.367 0 0 0 36 13.5a3.367 3.367 0 0 0-3.375 3.375z",
  fill: "currentColor",
  vectorEffect: "non-scaling-stroke"
})));

exports["default"] = SvgClock;
